import React from 'react';
import { ShoppingBag, CalendarCheck } from 'lucide-react';

// Distinguishes the *type* of sale at a glance: a shop product order vs an
// experience/booking. This is independent of sales channel (eBay / Square /
// Website …), which is surfaced separately via OrderSourceIcon.
//
// An order is an "experience" when its source is 'Booking' or its product
// name reads as an experience session; everything else is treated as a shop
// product order.
function isExperienceOrder(order) {
  const src = String(order?.source || '').toLowerCase();
  if (src.includes('booking')) return true;
  const name = String(order?.product_name || '').toUpperCase();
  return name.includes('EXPERIENCE') || name.includes('SESSION');
}

export default function OrderTypeIcon({ order, sourceLabel }) {
  const experience = isExperienceOrder(order);
  const label = experience ? 'Experience' : 'Shop Product';
  const channel = sourceLabel ? ` · ${sourceLabel}` : '';
  const Icon = experience ? CalendarCheck : ShoppingBag;
  const color = experience ? 'text-red-400' : 'text-sky-400';
  return (
    <Icon
      className={`w-4 h-4 ${color} shrink-0`}
      title={`${label}${channel}`}
      aria-label={label}
    />
  );
}